export enum SupplementalRuleIdentifierType {
    EmployeeUnitPerYearEvaluation = 0,
}
